import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { TracedRoutes } from '@comeon/error-reporter';
import Footer from '~/components/footer/index.js';
import {
	ROUTE_CASINO_GAME,
	ROUTE_CASINO_SEARCH,
	ROUTE_LIVE_CASINO_GAME,
	ROUTE_LIVE_CASINO_SEARCH,
	ROUTE_CAMPAIGN_REGISTER
} from '~/components/router/constants.js';
import { isSmallerSelector } from '~/components/layout/mediaquery.js';

const MOBILE_PATHS_WITHOUT_FOOTER = [
	ROUTE_CASINO_GAME,
	ROUTE_CASINO_SEARCH,
	ROUTE_LIVE_CASINO_GAME,
	ROUTE_LIVE_CASINO_SEARCH
];

const PATHS_WITHOUT_FOOTER = [ROUTE_CAMPAIGN_REGISTER];

const RoutesFooter = () => {
	const smaller = useSelector(isSmallerSelector);
	const FINAL_PATHS_WITHOUT_FOOTER = useMemo(() => {
		return [...(smaller ? MOBILE_PATHS_WITHOUT_FOOTER : []), ...PATHS_WITHOUT_FOOTER];
	}, [smaller]);
	return (
		<TracedRoutes>
			{FINAL_PATHS_WITHOUT_FOOTER.map(path => (
				<Route path={`${path}/*`} key={path} />
			))}
			<Route index element={<Footer isLandingPage />} />
			<Route path="*" element={<Footer />} />
		</TracedRoutes>
	);
};

export default RoutesFooter;
